import { AllowedFormData, createFormData, ensureFormHeader } from '../utils/form';
import { api, ApiRequest, ApiResponse } from '../instance';

export const putRaw = api.put;

export async function putFormRaw<T = any>(
  url: string,
  formData?: FormData | Record<string, AllowedFormData>,
  config: ApiRequest = {},
): Promise<ApiResponse<T>> {
  const postData = formData ? createFormData(formData) : undefined;
  const fullConfig = formData ? ensureFormHeader(config) : config;

  return putRaw<T>(url, postData, fullConfig);
}

export async function put<T = any>(
  url: string,
  postData?: any,
  config: ApiRequest = {},
): Promise<T> {
  return (await putRaw<T>(url, postData, config)).data;
}

export async function putForm<T = any>(
  url: string,
  formData?: FormData | Record<string, AllowedFormData>,
  config?: ApiRequest,
): Promise<T> {
  return (await putFormRaw<T>(url, formData, config)).data;
}
